import { Link } from 'react-router-dom';
import { Robot, ArrowLeft } from '@phosphor-icons/react';

function LegalLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-[#E4E4E7] px-8 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src="/images/novagente-logo.png" alt="Novagente" className="h-6" />
          </Link>
          <Link to="/" className="flex items-center gap-1 text-sm text-[#52525B] hover:text-[#09090B]">
            <ArrowLeft size={16} /> Volver al inicio
          </Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-8 py-12">
        <h1 className="font-black text-3xl tracking-tighter text-[#09090B] mb-8">{title}</h1>
        <div className="prose prose-sm max-w-none text-[#52525B] space-y-6">
          {children}
        </div>
      </main>
      <footer className="py-8 px-8 border-t border-[#E4E4E7]">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <span className="text-sm text-[#52525B]">© {new Date().getFullYear()} Novagente. Todos los derechos reservados.</span>
          <div className="flex gap-6 text-sm">
            <Link to="/terminos" className="text-[#52525B] hover:text-[#09090B]">Terminos y Condiciones</Link>
            <Link to="/privacidad" className="text-[#52525B] hover:text-[#09090B]">Aviso de Privacidad</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export function TermsAndConditions() {
  return (
    <LegalLayout title="Terminos y Condiciones">
      <p className="text-sm text-[#A1A1AA]">Ultima actualizacion: 27 de marzo de 2026</p>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">1. Aceptacion de los Terminos</h2>
        <p>
          Al acceder y utilizar la plataforma Novagente (en adelante "la Plataforma"), usted acepta estar sujeto a estos
          Terminos y Condiciones. Si no esta de acuerdo con alguno de estos terminos, no utilice la Plataforma.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">2. Descripcion del Servicio</h2>
        <p>
          Novagente es una plataforma de software como servicio (SaaS) que permite a las empresas crear agentes de inteligencia
          artificial (chatbots) conectados a WhatsApp Business. El servicio incluye:
        </p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>Creacion y configuracion de agentes de IA para atencion al cliente</li>
          <li>Integracion con WhatsApp Business a traves de Twilio</li>
          <li>Gestion de conversaciones y bandeja de entrada</li>
          <li>Planes de suscripcion con diferentes niveles de funcionalidad</li>
        </ul>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">3. Registro y Cuenta</h2>
        <p>
          Para utilizar la Plataforma, debe registrarse proporcionando informacion veraz, completa y actualizada.
          Usted es responsable de mantener la confidencialidad de sus credenciales de acceso y de todas las actividades
          que ocurran bajo su cuenta. Debe notificarnos inmediatamente de cualquier uso no autorizado.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">4. Planes y Pagos</h2>
        <p>
          La Plataforma ofrece diferentes planes de suscripcion con precios en Pesos Mexicanos (MXN).
          Los pagos se procesan a traves de Stripe. Al suscribirse a un plan de pago, usted acepta:
        </p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>Pagar las tarifas correspondientes a su plan seleccionado</li>
          <li>Que los cargos se realizaran de forma recurrente segun el periodo de facturacion</li>
          <li>Que puede cancelar su suscripcion en cualquier momento desde la configuracion de su cuenta</li>
          <li>Que no se realizan reembolsos por periodos parciales de uso</li>
        </ul>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">5. Uso Aceptable</h2>
        <p>Usted se compromete a no utilizar la Plataforma para:</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>Enviar mensajes no solicitados (spam) o contenido ilegal</li>
          <li>Suplantar la identidad de otra persona o entidad</li>
          <li>Interferir con el funcionamiento de la Plataforma o sus sistemas</li>
          <li>Violar las politicas de uso de WhatsApp Business o Meta</li>
          <li>Recopilar datos personales de terceros sin su consentimiento</li>
          <li>Distribuir malware, virus o cualquier codigo danino</li>
        </ul>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">6. Propiedad Intelectual</h2>
        <p>
          La Plataforma, incluyendo su codigo, diseno, logos, textos y demas contenido, son propiedad de Novagente
          y estan protegidos por las leyes de propiedad intelectual aplicables. El contenido generado por los agentes
          de IA es responsabilidad del usuario que configuro el agente.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">7. Integraciones de Terceros</h2>
        <p>
          La Plataforma utiliza servicios de terceros como Twilio (WhatsApp), Stripe (pagos), OpenAI (inteligencia artificial)
          y Meta (WhatsApp Business API). El uso de estos servicios esta sujeto a sus respectivos terminos y condiciones.
          Novagente no es responsable por interrupciones o cambios en estos servicios de terceros.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">8. Limitacion de Responsabilidad</h2>
        <p>
          Novagente proporciona la Plataforma "tal cual" y "segun disponibilidad". No garantizamos que el servicio
          sera ininterrumpido, seguro o libre de errores. En la maxima medida permitida por la ley, Novagente no sera
          responsable por danos indirectos, incidentales, especiales o consecuentes derivados del uso de la Plataforma.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">9. Suspension y Terminacion</h2>
        <p>
          Nos reservamos el derecho de suspender o cancelar su cuenta si viola estos Terminos y Condiciones,
          si utiliza la Plataforma de manera fraudulenta, o si no realiza los pagos correspondientes.
          En caso de terminacion, sus datos seran retenidos por un periodo de 30 dias, tras lo cual seran eliminados.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">10. Modificaciones</h2>
        <p>
          Nos reservamos el derecho de modificar estos Terminos en cualquier momento. Los cambios seran notificados
          a traves de la Plataforma o por correo electronico. El uso continuado de la Plataforma despues de la
          notificacion constituye la aceptacion de los terminos modificados.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">11. Legislacion Aplicable</h2>
        <p>
          Estos Terminos se rigen por las leyes de los Estados Unidos Mexicanos. Cualquier controversia sera resuelta
          por los tribunales competentes de la Ciudad de Mexico, renunciando las partes a cualquier otro fuero que
          pudiera corresponderles.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">12. Contacto</h2>
        <p>
          Para cualquier consulta sobre estos Terminos y Condiciones, puede contactarnos a traves de
          <strong> soporte@novagente.io</strong>.
        </p>
      </section>
    </LegalLayout>
  );
}

export function PrivacyPolicy() {
  return (
    <LegalLayout title="Aviso de Privacidad">
      <p className="text-sm text-[#A1A1AA]">Ultima actualizacion: 27 de marzo de 2026</p>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">1. Responsable del Tratamiento</h2>
        <p>
          Novagente (en adelante "el Responsable") con domicilio en Ciudad de Mexico, Mexico, es responsable del
          tratamiento de sus datos personales conforme a la Ley Federal de Proteccion de Datos Personales en Posesion
          de los Particulares (LFPDPPP) y su Reglamento.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">2. Datos Personales que Recopilamos</h2>
        <p>Recopilamos los siguientes datos personales:</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li><strong>Datos de identificacion:</strong> nombre, correo electronico</li>
          <li><strong>Datos de la empresa:</strong> nombre de la empresa, giro comercial</li>
          <li><strong>Datos de contacto:</strong> numeros de telefono asociados a WhatsApp Business</li>
          <li><strong>Datos de facturacion:</strong> informacion de pago procesada por Stripe (no almacenamos datos de tarjeta)</li>
          <li><strong>Datos de uso:</strong> conversaciones con clientes, mensajes, configuracion de agentes</li>
          <li><strong>Datos tecnicos:</strong> direccion IP, tipo de navegador, horarios de acceso</li>
        </ul>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">3. Finalidades del Tratamiento</h2>
        <p>Sus datos personales seran utilizados para las siguientes finalidades primarias:</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>Crear y administrar su cuenta en la Plataforma</li>
          <li>Prestar los servicios contratados (agentes de IA, WhatsApp Business)</li>
          <li>Procesar pagos y gestionar suscripciones</li>
          <li>Enviar notificaciones relacionadas con el servicio</li>
          <li>Brindar soporte tecnico y atencion al cliente</li>
          <li>Cumplir con obligaciones legales y regulatorias</li>
        </ul>
        <p className="mt-2">Finalidades secundarias:</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>Enviar comunicaciones de marketing y promociones (con su consentimiento)</li>
          <li>Mejorar nuestros servicios mediante analisis de uso</li>
          <li>Realizar estudios internos sobre preferencias de los usuarios</li>
        </ul>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">4. Transferencia de Datos</h2>
        <p>
          Sus datos personales podran ser transferidos a los siguientes terceros para el cumplimiento de las
          finalidades descritas:
        </p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li><strong>Twilio Inc.</strong> (EE.UU.) - Para la integracion con WhatsApp Business</li>
          <li><strong>Stripe Inc.</strong> (EE.UU.) - Para el procesamiento de pagos</li>
          <li><strong>OpenAI</strong> (EE.UU.) - Para el funcionamiento de los agentes de IA</li>
          <li><strong>Meta Platforms</strong> (EE.UU.) - Para la vinculacion con WhatsApp Business API</li>
          <li><strong>Amazon Web Services</strong> (EE.UU.) - Para el envio de notificaciones por correo</li>
        </ul>
        <p className="mt-2">
          Estas transferencias se realizan conforme a las excepciones previstas en la LFPDPPP y bajo los
          terminos de privacidad de cada proveedor.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">5. Derechos ARCO</h2>
        <p>
          Usted tiene derecho a Acceder, Rectificar, Cancelar u Oponerse al tratamiento de sus datos personales
          (derechos ARCO). Para ejercer estos derechos, envie un correo electronico a <strong>privacidad@novagente.io</strong> con
          la siguiente informacion:
        </p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>Nombre completo y correo electronico asociado a su cuenta</li>
          <li>Descripcion clara del derecho que desea ejercer</li>
          <li>Documentos que acrediten su identidad</li>
        </ul>
        <p className="mt-2">
          Responderemos su solicitud en un plazo maximo de 20 dias habiles.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">6. Medidas de Seguridad</h2>
        <p>
          Implementamos medidas de seguridad administrativas, tecnicas y fisicas para proteger sus datos personales,
          incluyendo:
        </p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>Cifrado de contrasenas mediante algoritmos de hash (bcrypt)</li>
          <li>Autenticacion mediante tokens JWT con expiracion</li>
          <li>Comunicaciones cifradas mediante HTTPS/TLS</li>
          <li>Datos de pago procesados por Stripe (certificado PCI DSS) sin almacenamiento local</li>
          <li>Acceso restringido a bases de datos mediante credenciales protegidas</li>
        </ul>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">7. Cookies y Tecnologias de Rastreo</h2>
        <p>
          La Plataforma utiliza almacenamiento local del navegador (localStorage) para mantener su sesion activa.
          No utilizamos cookies de rastreo de terceros con fines publicitarios.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">8. Conservacion de Datos</h2>
        <p>
          Sus datos personales seran conservados mientras mantenga una cuenta activa en la Plataforma.
          En caso de cancelacion de cuenta, los datos seran eliminados en un plazo de 30 dias, salvo aquellos
          que debamos conservar por obligaciones legales o fiscales.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">9. Datos de Conversaciones</h2>
        <p>
          Los mensajes intercambiados entre sus clientes y los agentes de IA son almacenados en la Plataforma
          para permitir el funcionamiento del servicio. Usted es responsable de informar a sus clientes sobre
          el uso de agentes de IA y el tratamiento de sus datos conforme a la legislacion aplicable.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">10. Modificaciones al Aviso de Privacidad</h2>
        <p>
          Nos reservamos el derecho de modificar este Aviso de Privacidad en cualquier momento. Cualquier cambio
          sera notificado a traves de la Plataforma o por correo electronico. La version vigente estara siempre
          disponible en esta pagina.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-lg text-[#09090B] mb-2">11. Contacto</h2>
        <p>
          Para dudas o comentarios sobre este Aviso de Privacidad, contactenos en:
        </p>
        <ul className="list-none space-y-1 mt-2">
          <li><strong>Correo:</strong> privacidad@novagente.io</li>
          <li><strong>Soporte:</strong> soporte@novagente.io</li>
        </ul>
      </section>
    </LegalLayout>
  );
}
